type MaritalStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
type MaritalStatusMap = {
    [Key in MaritalStatus]: string;
}
const MartialStatusTextMap: MaritalStatusMap = {
    0: "Unknown",
    1: "Unmarried",
    2: "Married",
    3: "Divorced",
    4: "Widowed",
    5: "Separated",
    6: "Domestic Partnership",
    7: "Polygamous",
    8: "Anulled",
    9: "Subject to interlocutory decree",

};
export function maritalStatusToText(status: MaritalStatus) {
    return MartialStatusTextMap[status];
}
export function getMaritalStatusValues(): Array<{ key: number, text: string }> {
    return Object.keys(MartialStatusTextMap).map(key => ({ key: +key, text: MartialStatusTextMap[+key as MaritalStatus] }));
}


type AllergySeverity = 0 | 1 | 2;
export function allergySeverityToText(severity: AllergySeverity) {
    switch (severity) {
        case 0: return "Unknown"
        case 1: return "Low";
        case 2: return "High"
        default: return "?";
    }
}


type DocumentSignatureKind = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;
export type DocumentSignatureKindText =
    "unknown" | "author" | "co_author" | "participant" |
    "transcriptionist" | "verification" | "validation" |
    "consent" | "signature_witness" | "event_witness" |
    "identity_witness" | "consent_witness" | "interpreter" |
    "review" | "source" | "addendum" | "modification" |
    "administrative_error" | "timestamp";
type DocumentSignatureKindMap = {
    [Key in DocumentSignatureKind]: { display: string, id: DocumentSignatureKindText };
}
type DocumentSignatureKindReverseMap = {
    [Key in DocumentSignatureKindText]: DocumentSignatureKind;
}
const DocumentSignatureKindTextMap: DocumentSignatureKindMap = {
    0: { display: "Unknown", id: "unknown" },
    1: { display: "Author", id: "author" },
    2: { display: "Co-Author", id: "co_author" },
    3: { display: "Co-Participant", id: "participant" },
    4: { display: "Transcriptionist", id: "transcriptionist" },
    5: { display: "Verification", id: "verification" },
    6: { display: "Validation", id: "validation" },
    7: { display: "Consent", id: "consent" },
    8: { display: "Signature witness", id: "signature_witness" },
    9: { display: "Event witness", id: "event_witness" },
    10: { display: "Identity witness", id: "identity_witness" },
    11: { display: "Consent witness", id: "consent_witness" },
    12: { display: "Interpreter", id: "interpreter" },
    13: { display: "Reviewer", id: "review" },
    14: { display: "Source", id: "source" },
    15: { display: "Addendum", id: "addendum" },
    16: { display: "Modification", id: "modification" },
    17: { display: "Administrative error/edit", id: "administrative_error" },
    18: { display: "Timestamp", id: "timestamp" }
};
const DocumentSignatureKindReverseTextMap: DocumentSignatureKindReverseMap = {
    "unknown": 0,
    "author": 1,
    "co_author": 2,
    "participant": 3,
    "transcriptionist": 4,
    "verification": 5,
    "validation": 6,
    "consent": 7,
    "signature_witness": 8,
    "event_witness": 9,
    "identity_witness": 10,
    "consent_witness": 11,
    "interpreter": 12,
    "review": 13,
    "source": 14,
    "addendum": 15,
    "modification": 16,
    "administrative_error": 17,
    "timestamp": 18
};
export function documentSignatureKindToText(status: DocumentSignatureKind) {
    return DocumentSignatureKindTextMap[status]?.display;
}
export function documentSignatureKindToId(status: DocumentSignatureKind) {
    return DocumentSignatureKindTextMap[status]?.id;
}
export function getDocumentSignatureKindValues(): Array<{ key: number, text: string }> {
    return Object.keys(DocumentSignatureKindTextMap).map(key => ({ key: +key, text: DocumentSignatureKindTextMap[+key as DocumentSignatureKind].display }));
}
export function documentSignatureTextToKind(status: DocumentSignatureKindText) {
    return DocumentSignatureKindReverseTextMap[status];
}

export type SurgeryStatusType = 0 | 1 | 2 | 3 | 4 | 5 | 6;
type SurgeryStatusTypeMap = {
    [Key in SurgeryStatusType]: string;
}

const SurgeryStatusTypeTextMap: SurgeryStatusTypeMap = {
    0: "Pending",
    1: "Active",
    2: "Canceled",
    3: "Soft-canceled",
    4: "Complete",
    5: "Canceled \u2014 Not needed",
    6: "Failed"
}
export function surgeryStatusToText(status: SurgeryStatusType) {
    return SurgeryStatusTypeTextMap[status] || "Unknown";
}

export function raceToString(race: number) {
    switch (race) {
        case 0: return "Unknown";
        case 1: return "Declined";
        case 2: return "Other";
        case 100: return "White";
        case 200: return "Black / African American";
        case 300: return "American Indian / Alaskan Native";
        case 400: return "Asian";
        case 500: return "Native Hawaiian / Pacific Islander";
        case 600: return "Hispanic / Latino";
        default: return `Unknown (${race})`;
    }
}

export function sexToString(sex: string) {
    switch (sex) {
        case "F": return "Female";
        case "M": return "Male";
        case "X": return "Other";
        default: return "Unknown";
    }
}
